<template>
    <div class="list">
        <ul v-if="dataList.length > 0">
            <li v-for="(item,index) in dataList"
                :key="index">
                <OnlyTitle v-if="item.displayType == 1"
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>
                <TopTitleBottomImage v-else-if="item.displayType == 2"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </TopTitleBottomImage>
                <OneTitleThreeImage v-else-if="item.displayType == 3"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </OneTitleThreeImage>
                <LeftTitleRightImage v-else-if="item.displayType == 4"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </LeftTitleRightImage>
                <TopTitleThreeImage v-else-if="item.displayType == 5"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </TopTitleThreeImage>
                <OnlyTitle v-else
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>
            </li>
        </ul>
        <div class="load-box" v-if="dataList.length > 0">
            <a href="javascript:;" @click="getNewList">{{topic}}</a>
        </div>
        <div class="no-data" v-else>
            <p>
                <img src="../../assets/images/no_data.png" alt="" />
            </p>
            <p>该列表暂时还没有数据</p>
        </div>
    </div>
</template>

<script>
import List from "../list/index";

export default{
    name: 'ChannelList',
    data(){
        return{
            id: this.$route.params.id,
            dataList: [],
            page: 1,
            topic: '点击加载更多',
            bLen: 0
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            this.axios.get("/webtopic/list", {
                params:{
                    cateId: this.id,
                    page: 1,
                    limit: 10
                }
            }).then((res) => {
                this.dataList = res.data.data
            })
        },
        getNewList(){
            let nLen = this.dataList.length + 10;
            if(nLen > this.bLen){
                this.topic = '已经没有更多了';
                return
            }
            this.page++;
            this.topic = '正在加载...';
            setTimeout(() => {
                this.axios.get("/webtopic/list", {
                    params:{
                        cateId: this.id,
                        page: this.page,
                        limit: 10
                    }
                }).then((res) => {
                    this.topic = '点击加载更多';
                    this.dataList = this.dataList.concat(res.data.data);
                })
            }, 500)
        },
    },
    components: {
        OnlyTitle: List.OnlyTitle,
        TopTitleBottomImage: List.TopTitleBottomImage,
        OneTitleThreeImage: List.OneTitleThreeImage,
        LeftTitleRightImage: List.LeftTitleRightImage,
        TopTitleThreeImage: List.TopTitleThreeImage,
    }
}
</script>

<style lang="less" scoped>
    .list{
        padding-bottom: 1.5rem;
    }
    ul li {
        margin: 0 0.3rem;
        padding: 0.4rem 0;
        border-bottom: 1px solid rgba(221, 221, 221, 0.6);
    }
    .load-box{
        text-align: center;
        a{
            padding: 0.35rem 0;
            font-size: 0.36rem;
            color: #333;
            display: block;
        }
    }
    .no-data{
        text-align: center;
        font-size: 0.4rem;
        padding-top: 5rem;
        p{
            margin-bottom: 0.3rem;
            color: #333;
        }
        img{
            width: 28%;
        }
    }       
</style>   